module.exports = __webpack_public_path__ + "img/GBPUSD.290892bf.png";